/**
 * ヘッダースクロール機能
 * ヘッダーの高さまでスクロールした際に背景色とテキスト色を変更
 */

export function initializeHeaderScroll() {
  const header = document.querySelector('.m-header');

  if (!header) {
    return;
  }

  // ハンバーガーライン要素を取得
  const hamburgerLines = document.querySelectorAll('.m-hamburger__line');

  // ヘッダーの高さを取得（CSS変数から）
  const headerHeight =
    parseInt(
      getComputedStyle(document.documentElement).getPropertyValue(
        '--js-height__header',
      ),
    ) || 80;

  // スクロールイベントの処理
  function handleScroll() {
    const scrollY = window.scrollY;

    if (scrollY >= headerHeight) {
      header.classList.add('is-scrolled');
      hamburgerLines.forEach((line) => line.classList.add('is-scrolled'));
    } else {
      header.classList.remove('is-scrolled');
      hamburgerLines.forEach((line) => line.classList.remove('is-scrolled'));
    }
  }

  // スクロールイベントリスナーを追加
  window.addEventListener('scroll', handleScroll, { passive: true });

  // 初期状態をチェック
  handleScroll();
}
